import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Button, Tooltip } from 'antd';
import { getViewerModuleTempDashboardUrl } from '@components/common/Dashboard/utils/getTempDashboardUrl';
import { createTempDashboard } from '@store/tempDashboard/actions';
import {
  DASHBOARD_TYPE,
  INTERNAL_UNKNOWN,
  INTERNAL_UNKNOWN_TOOLTIP,
  UNKNOWN,
  UNKNOWN_TOOLTIP,
} from '@utils/constants';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Actions from './Actions';
import { CellContentWrapper } from './styled';
import { openNewTab } from '@src/utils/dashboard/drilldown';
interface IProps {
  data: string | number;
  cellStyle: object;
}

const ViewerIdRender = styled(Button)`
  && {
    margin: 0;
    padding-left: 0;
  }
`;

const RenderViewerId = ({ data, cellStyle = {} }: IProps) => {
  const dispatch = useDispatch();

  const handleSearch: any = () => {
    if (data) {
      // callback to push new temp tab url
      const redirectHandler = ({ id }) => {
        const url = getViewerModuleTempDashboardUrl(data, id);
        openNewTab(url);
      };

      // create local storage entry
      dispatch(
        createTempDashboard(DASHBOARD_TYPE.VIEWER_MODULE, { viewerId: data }, `Viewer - ${data}`, {
          redirectHandler,
        }),
      );
    }
  };

  const navigateToViewer = React.useCallback(() => {
    handleSearch();
  }, [data]);

  let title = '';
  if (data === INTERNAL_UNKNOWN) {
    title = INTERNAL_UNKNOWN_TOOLTIP;
  }
  if (data === UNKNOWN) {
    title = UNKNOWN_TOOLTIP;
  }

  return (
    <CellContentWrapper style={cellStyle}>
      <div style={{ display: 'inline-block' }}>
        <Tooltip title="Click to see Viewer Details">
          <ViewerIdRender onClick={navigateToViewer} type="link">
            {data === INTERNAL_UNKNOWN ? 'VIEWERID_UNKNOWN' : data}
          </ViewerIdRender>
        </Tooltip>
        {title && (
          <Tooltip title={title}>
            <QuestionCircleOutlined style={{ marginLeft: '3px' }} />
          </Tooltip>
        )}
      </div>
      <Actions data={data} viewerId={data} />
    </CellContentWrapper>
  );
};

export default RenderViewerId;
